import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Organization } from 'src/app/domain/organization/dto/Organization';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/domain/auth/service/auth.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { OrganizationsService } from 'src/app/domain/organization/components/service/organizations.service';
import { ToolTipSettings } from 'src/app/domain/shared/component/tooltip/tooltip.util';
import {
  getKpiCompanyMetricsUrl,
  getKpiCrossPortfolioUrl,
  KPI_URLS,
} from '../../../domain/kpi/module/kpi-module-routing.module';
import { EmployeeRole } from '../hornavbar/dto/InitDataDTO';
import { fadeInOutAnimation } from '../../../util/animations/fade-in-out.animation';
import { FP_URLS } from '../../../domain/fund-performance/component/fund-performances/pojo/FP_URLS';
import { FS_URLS } from '../../../domain/financial-statement/module/financial-statement-routing.module';
import { FsGettersSettersService } from '../../../domain/financial-statement/services/common/fs-getters-setters.service';
import {
  FinancialStatementService,
} from '../../../domain/financial-statement/services/common/financial-statement.service';
import { OwnershipEntityType } from '../../../domain/financial-statement/utils/common/utilityClasses';
import { PP_URLS } from "../../../domain/pp/component/base/dto/PpTab";
import { ORG_URLS } from "../../../domain/organization/dto/ORG_URLS";
import { INVESTORS_URL } from '../../../domain/investors-and-net-irr/dto/InvestorsURL';
import { CP_URLS } from '../../../domain/company-performance/dto/CP_URLS';
import { DEFAULT_DROP_DOWN_DELAY_TIME, DelayService } from "../../service/delay.service";

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  animations: [fadeInOutAnimation(200, 50)],
  providers: [DelayService],
})
export class SideNavComponent implements OnInit, AfterViewInit, OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();
  private _fsDestroyStream: Subject<void> = new Subject<void>();

  currentService = {
    fms: true,
    financial: false,
    dataRoom: false,
    marketAnalysis: false,
    kpi: false,
    portal: false,
  };

  showService = {
    fms: true,
    dataRoom: false,
    financialStatement: false,
    marketAnalysis: false,
    kpi: false,
    portal: false,
  };

  showSubmenu = {
    overview: {
      isShown: false,
      isStyleActive: false,
    },
    predictionModels: {
      isShown: false,
      isStyleActive: false,
    },
  };

  links = {
    organization: ORG_URLS.BASE,
    portfolioPerformances: FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base,
    fundPerformances: FP_URLS.BASE,
    periodComparison: PP_URLS._comparison,
    companies: `portfoliocompanies`,
    irr: `portfolio-performance`,
    holding: `next-round-allocation`,
    followOnModel: `growth-potential`,
    fundStrategy: `fund-strategy`,
    fundBudgetModel: `fund-budget`,
    marketAnalysisByIndustry: `market-analysis/by-industry`,
    marketAnalysisByVintage: `market-analysis/by-vintage`,
    marketAnalysisByStock: `market-analysis/by-stock`,
    crossPortfolio: getKpiCrossPortfolioUrl(),
    kpiCompanies: getKpiCompanyMetricsUrl(),
    bulkRequest: KPI_URLS.base + '/' + KPI_URLS._bulkRequest,
    investorReport: `investor-report`,
    fsWorkingPapers: FS_URLS.base + '/' + FS_URLS._workingPaper,
    fsFinancialAnalytics: FS_URLS.base + '/' + FS_URLS._financialsAnalytics,
    fsCapitalAccounts: FS_URLS.base + '/' + FS_URLS._capAccounts,
    cashFlowDealFlow: `cashflow-matrix`,
    entrance: `entrance`,
    investors: INVESTORS_URL.BASE,
    companyPerformance: CP_URLS.BASE,
  };

  selectedOrganization: Organization;
  isDemo = false;
  isStaging = false;
  isPreDemo = false;

  isAdminChosen = false;
  isAdminInsideOrg = false;
  isFundsEmpty = true;
  hasFs = false;
  isFsForFund = false;

  isFundActive = false;

  toolTipSettings: ToolTipSettings = {
    show: false,
  };

  constructor(
    private authService: AuthService,
    private router: Router,
    private organizationsService: OrganizationsService,
    private fsGetterSetter: FsGettersSettersService,
    private fsService: FinancialStatementService,
    private delayService: DelayService,
  ) {
  }

  ngOnInit(): void {
    this.initData();
    this.initSubscriptions();
  }

  ngAfterViewInit(): void {
    this.delayService.initSubscribes(DEFAULT_DROP_DOWN_DELAY_TIME, this.showDropDown, this.hideDropDown);
  }

  activateDropDown(): void {
    this.delayService.activate();
  }

  deactivateDropDown(): void {
    this.delayService.deactivate();
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
    this.isAdminChosen = null;
    this.fsUnsubscribe();
  }

  fsUnsubscribe(): void {
    this._fsDestroyStream.next();
    this._fsDestroyStream.complete();
  }

  defineSideNavIconsVisibility(currentURL: string): void {
    const urlWithoutQueryParams = currentURL.split('?')[0];
    const doesUrlIncludeService = (service: string): boolean => urlWithoutQueryParams.includes(service);
    let selectedService = 'fms';
    if (doesUrlIncludeService('market-analysis')) {
      selectedService = 'marketAnalysis';
    } else if (doesUrlIncludeService('kpi') && !doesUrlIncludeService(CP_URLS.BASE)) {
      selectedService = 'kpi';
    } else if (doesUrlIncludeService(FS_URLS.base)) {
      selectedService = FS_URLS.base;
      this.initFsSubscription();
    } else if (doesUrlIncludeService('data-room')) {
      selectedService = 'data-room';
    }


    this.showService = {
      fms: false,
      financialStatement: false,
      dataRoom: false,
      marketAnalysis: false,
      kpi: false,
      portal: false,
    };
    this.showService[selectedService] = true;
  }

  activateTooltip(id: string, text: string): void {
    this.toolTipSettings = {
      show: true,
      coordinates: document.getElementById(id).getBoundingClientRect(),
      title: text,
    };
  }

  private initData(): void {
    if (window.location.hostname.includes('pre-demo')) {
      this.isPreDemo = true;
    } else if (window.location.hostname.includes('demo')) {
      this.isDemo = true;
    }
    if (window.location.hostname.includes('staging')) {
      this.isStaging = true;
    }
    this.defineSideNavIconsVisibility(this.router.url);
    this.defineSideNavActiveClass(this.router.url);
  }

  private initSubscriptions(): void {
    this.initRouterSubscription();
    this.initOrgSubscription();
    this.initAuthSubscription();
  }

  private initOrgSubscription(): void {
    this.organizationsService.selectedWithAccesses$.pipe(takeUntil(this._destroyStream)).subscribe((wrapper) => {
      if (!wrapper) {
        return;
      }
      this.selectedOrganization = wrapper.organization;
      this.isFundsEmpty = this.selectedOrganization.funds.length === 0;
      const orgAccesses = wrapper.userAccesses;
      this.currentService.fms = orgAccesses.fmsAccess !== EmployeeRole.noAccess;
      this.currentService.financial = orgAccesses.financialStatementAccess !== EmployeeRole.noAccess;
      this.currentService.kpi = orgAccesses.kpiAccess !== EmployeeRole.noAccess;
      this.currentService.marketAnalysis = orgAccesses.marketAnalysisAccess !== EmployeeRole.noAccess;
      this.currentService.portal = orgAccesses.portalAccess !== EmployeeRole.noAccess;
    });
  }

  private initRouterSubscription(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this._destroyStream))
      .subscribe((event) => {
        if (!(event instanceof NavigationEnd)) {
          return;
        }
        if (!event.url.includes(FS_URLS.base)) {
          this.fsUnsubscribe();
        }
        this.defineSideNavIconsVisibility(event.url);
        this.defineSideNavActiveClass(event.url);
      });
  }

  private defineSideNavActiveClass(url: string): void {
    const overviewLinks: string[] = [
      this.links.portfolioPerformances,
      this.links.cashFlowDealFlow,
      this.links.companies,
    ];
    const predictionModelsLinks: string[] = [
      this.links.followOnModel,
      this.links.irr,
      this.links.fundStrategy,
      this.links.fundBudgetModel,
    ];
    this.showSubmenu.overview.isStyleActive = overviewLinks.map((link) => url.startsWith('/' + link)).includes(true);
    this.showSubmenu.predictionModels.isStyleActive = predictionModelsLinks.map((link) => url.startsWith('/' + link)).includes(true);
    this.isFundActive = url.startsWith('/' + this.links.periodComparison)
      || url.startsWith('/' + this.links.fundPerformances)
      || url.startsWith('/' + this.links.companyPerformance);
  }

  private initAuthSubscription(): void {
    this.authService.currentUserTypeForServices$.pipe(takeUntil(this._destroyStream)).subscribe((userType) => {
      if (!userType) {
        return;
      }
      this.isAdminChosen = userType === 'admin';
    });

    this.authService.fmsAccessInsideOrganizationForServices$.pipe(takeUntil(this._destroyStream)).subscribe((userType) => {
      if (!userType) {
        return;
      }
      this.isAdminInsideOrg = userType.toString().includes('admin');
    });
  }

  private initFsSubscription(): void {
    this.fsGetterSetter.financialStatement
      .pipe(takeUntil(this._fsDestroyStream))
      .subscribe((financialStatement) => {
        this.hasFs = Boolean(financialStatement);
        this.isFsForFund = this.fsService.ownershipEntityType === OwnershipEntityType.FUND;
      });
  }

  private showDropDown: () => void = () => {
    this.showSubmenu.predictionModels.isShown = true;
  };

  private hideDropDown: () => void = () => {
    this.showSubmenu.predictionModels.isShown = false;
  };
}

// Cannot move to the modal-stay component because then there is circular dependency.
// See (https://stackoverflow.com/questions/56870661/angular-7-2-1-es6-class-referenceerror-cannot-access-x-before-initializatio)
export const BROADCAST_CHANNEL_NAME = 'last_action_counter';
export const BROADCAST_CHANNEL_LOGOUT = 'logout';
export const BROADCAST_CHANNEL_LOGOUT_MESSAGE = 'logout';
